import { cn } from '../../lib/cn';

const variants = {
  primary: [
    'bg-gradient-to-b from-gray-800 to-black text-white',
    'dark:from-white dark:to-gray-200 dark:text-gray-900',
    'shadow-[0_2px_8px_rgba(0,0,0,0.2)]',
    'hover:shadow-[0_4px_12px_rgba(0,0,0,0.3)]',
    'hover:from-gray-700 hover:to-gray-900',
    'dark:hover:from-gray-100 dark:hover:to-gray-300',
    'active:shadow-[0_1px_4px_rgba(0,0,0,0.2)]',
    'disabled:from-gray-300 disabled:to-gray-400 disabled:text-gray-500 disabled:cursor-not-allowed disabled:shadow-none',
    'dark:disabled:from-gray-600 dark:disabled:to-gray-700 dark:disabled:text-gray-400',
  ].join(' '),
  secondary: [
    'bg-white text-gray-900 border border-gray-200',
    'dark:bg-gray-800 dark:text-white dark:border-gray-600',
    'shadow-[0_1px_4px_rgba(0,0,0,0.06)]',
    'hover:shadow-[0_2px_8px_rgba(0,0,0,0.1)] hover:border-gray-300',
    'dark:hover:border-gray-500',
    'active:shadow-none active:bg-gray-50 dark:active:bg-gray-700',
    'disabled:bg-gray-50 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed disabled:shadow-none',
    'dark:disabled:bg-gray-700 dark:disabled:text-gray-500 dark:disabled:border-gray-600',
  ].join(' '),
  ghost: [
    'bg-transparent text-gray-600 dark:text-gray-400',
    'hover:text-gray-900 hover:bg-gray-100',
    'dark:hover:text-white dark:hover:bg-gray-700',
    'active:bg-gray-200 dark:active:bg-gray-600',
    'disabled:text-gray-300 disabled:cursor-not-allowed disabled:hover:bg-transparent',
    'dark:disabled:text-gray-600',
  ].join(' '),
  danger: [
    'bg-gradient-to-b from-red-500 to-red-600 text-white',
    'shadow-[0_2px_8px_rgba(239,68,68,0.3)]',
    'hover:shadow-[0_4px_12px_rgba(239,68,68,0.4)]',
    'hover:from-red-400 hover:to-red-500',
    'active:shadow-[0_1px_4px_rgba(239,68,68,0.2)]',
    'disabled:from-gray-300 disabled:to-gray-400 disabled:text-gray-500 disabled:cursor-not-allowed disabled:shadow-none',
    'dark:disabled:from-gray-600 dark:disabled:to-gray-700 dark:disabled:text-gray-400',
  ].join(' '),
};

const sizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-5 py-2.5 text-base',
  lg: 'px-7 py-3.5 text-lg',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  className,
  disabled = false,
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={cn(
        'inline-flex items-center justify-center font-medium rounded-lg',
        'transition-all duration-200 ease-out',
        'focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 dark:focus:ring-offset-gray-900',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
